<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :bank-account="bankAccount"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/BankAccounts/Form.vue'

const props = defineProps({
    bankAccount: {
        type: Object,
        default: () => {
            return {}
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.put(route('settings.bank-accounts.update', { bankAccount: props.bankAccount.id }))
}
</script>
